export default "__VITE_ASSET__Cv9igQ6A__"